export enum IntercomEventEnum {
  SEARCH = "search",
  BOOK = "Book",
  QUOTE_REQUEST = "Quote-Request",
  SIGN_IN = "Sign in",
}
